import { Component, Input, OnChanges, SimpleChanges, Output, EventEmitter } from "@angular/core";
import { TaxonomyService } from "../services/taxonomy.service";
import { tap } from "rxjs/operators";
import { of } from "rxjs";

@Component({
    selector: 'catalog-topic-category-manager',
    template: `
        <mat-chip-list *ngIf="topic">
                <ng-container *ngFor="let categoryDetails of topic.catalogCategories">
                    <mat-chip *ngIf="!categoryDetails.isDeleted" color="primary">{{categories[categoryDetails.categoryId]?.label}}</mat-chip>
                </ng-container>
                <mat-chip (click)="categoryPanel.open()" color="primary" *ngIf="!categoryPanelOpen">Categorize <mat-icon>notes</mat-icon></mat-chip>
        </mat-chip-list>
        <mat-expansion-panel #categoryPanel (opened)="categoryPanelOpen = true" (closed)="categoryPanelOpen = false" style="margin-top: 15px;">
            <div style="padding-top: 15px;">
                <div style="height: 35px;">
                    <button mat-icon-button 
                            (click)="categoryPanel.close()" 
                            matTooltip="Close"
                            style="float: right"><mat-icon>cancel</mat-icon></button>
                </div>
                <mat-selection-list #list>
                    <ng-container *ngFor="let categoryDetails of categoryList">
                        <mat-list-option *ngIf="categoryDetails.category.id !== 'uncategorized'"
                                         [value]="categoryDetails.category.id" 
                                         [selected]="categoryIsSelected(categoryDetails.category.id)"
                                         (click)="selectedOptionsChanged(list.selectedOptions.selected)">
                            <div [ngStyle]="{'padding-left': categoryDetails.isParent ? '0px' : '30px'}">
                                <span *ngIf="categoryIsSelected(categoryDetails.category.id)" style="font-weight: bold;">{{categoryDetails.category.title}}</span>
                                <span *ngIf="!categoryIsSelected(categoryDetails.category.id)">{{categoryDetails.category.title}}</span>
                            </div>
                        </mat-list-option>
                    </ng-container>
                </mat-selection-list>
            </div>
        </mat-expansion-panel>
    `
})
export class CatalogTopicCategoryManagerComponent implements OnChanges {
    @Input() topic: any;
    @Input() catalogId;
    @Output() changed = new EventEmitter();    
    categories: any;
    taxonomy: any;
    categoryPanelOpen: boolean;

    constructor(private taxonomyService: TaxonomyService) {}

    get categoryList(): any[] {
        return Object.values(this.categories);
    }

    categoryIsSelected(categoryId): boolean {
        return !!this.topic.catalogCategories.find(det => det.categoryId === categoryId && !det.isDeleted);
    }

    selectedOptionsChanged(opts) {
        const selectedIds = opts.map(opt => opt.value);
        this.topic.catalogCategories.forEach(catCat => catCat.isDeleted = !selectedIds.includes(catCat.categoryId));
        const addables = selectedIds.filter(selectedId => !this.topic.catalogCategories.find(catCat => catCat.categoryId === selectedId));
        addables.forEach(addable => this.topic.catalogCategories.push({ categoryId: addable, isNew: true }));
        this.changed.emit();
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.categories = {};

        if (changes.catalogId) {
            this.taxonomy = undefined;
        }

        const taxonomyFetch = this.catalogId ?
            this.taxonomyService.getTenantlessCatalogTaxonomy(this.catalogId, { filterEmpty: false }) :
            this.taxonomyService.getTenantTaxonomy(false, false, true);

        (this.taxonomy ? of(this.taxonomy) : taxonomyFetch)
        .pipe(tap(taxonomy => this.taxonomy = taxonomy))
        .subscribe(() => {
            this.taxonomy?.forEach(category => {
                this.categories[category.id] = { label: category.title, category, isParent: true };
                category.subcategories?.forEach(subcat => this.categories[subcat.id] = { label: `${category.title} > ${subcat.title}`, category: subcat});
            });
        });        
    }
}